module["exports"] = [  
  "##",
  "#"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/id_ID/address/building_number.js
// module id = 1738
// module chunks = 0